<template>
  <div class="jumbotron">
		<h3>Já tem uma conta?</h3>
		<p>Se ainda não tem uma conta na Workix, você pode criar uma em poucos segundos com seu e-mail ou sua conta Google.</p>
		<p><a class="btn btn-primary link-login">Entrar</a></p>
	</div>
</template>

<script>
export default {

}
</script>

<style>

</style>